import { useTheme } from '@material-ui/core';
import { Copyright } from 'app/components/Copyright';
import styled from 'styled-components';

export interface FooterContentProps {
  isMobile?: boolean;
}
export const FooterSection = styled('div')(({ theme }) => ({
  '&.footerSection': {
    display: 'flex',
    width: '100%',
    padding: '8px 16px 12px 16px',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '10px',
  },
}));
export function FooterContent(props: FooterContentProps) {
  const theme = useTheme();
  return (
    <FooterSection theme={theme} className={'footerSection'}>
      <Copyright disableVersionOnMobile={props.isMobile} />
    </FooterSection>
  );
}
